
umpApp.intro = {
    indexFrame: 0,
    playInfoText: false,
    slide: 1,
    slidePlayed: 0,
    timeBreak: false,
    timeline_1s: gsap.timeline({ defaults: { duration: 1, ease: "Power3.easeIn" } }),
    timeLine3dIn: gsap.timeline({ defaults: { duration: 1, ease: "Power3.easeIn" } }),
    timeLine3dOut: gsap.timeline({ defaults: { duration: 1, ease: "Power3.easeOut" } }),
    timeLine_16s: gsap.timeline({ defaults: { duration: 16 } }),
    timeline_scrollInfo: gsap.timeline({ defaults: { duration: 1, ease: "Power3.easeIn" } }),
    timeline_sieWeb: gsap.timeline({ defaults: { duration: 1, ease: "Power3.easeIn" } }),
    tween: false,
    idAF: null,
    _this: this,
    seqTimeLine: [
        {//0
            play: function () {
                console.log("slide 0 !");
                umpApp.intro.slidePlayed = 0;
            },
            reverse: function () {
                console.log("slide 0 !");
                umpApp.intro.slidePlayed = 0;
            }
        },
        {//1 scene text 1 -> 2
            play: function () {
                console.log("play slide ", umpApp.intro.slide);
                umpApp.intro.timeline_1s.clear();
                umpApp.intro.timeline_1s.to(".scene.text-one", {
                    height: 0,
                    onComplete: function () {
                        umpApp.intro.slidePlayed = 1;
                        $("#intro-3d").css({ "display": "block" });

                        umpApp.intro.timeline_scrollInfo.clear();
                        umpApp.intro.timeline_scrollInfo.to(".container-scroll-info", {
                            opacity: 1,
                            onStart: function () {
                                $(".container-scroll-info").css({ "display": "block" });
                                $(".text-scroll").css({ "color": "#fff" });
                            }
                        });

                    }
                });

            },
            reverse: function () {
                console.log("reverse slide ", umpApp.intro.slide);
                umpApp.intro.timeline_1s.clear();
                umpApp.intro.timeline_1s.to(".scene.text-one", {
                    height: "100vh",
                    onComplete: function () {
                        umpApp.intro.slidePlayed = 0;
                        $("#intro-3d").css({ "display": "none" });
                        umpApp.intro.timeline_scrollInfo.to(".container-scroll-info", {
                            opacity: 1,
                            onStart: function () {
                                $(".container-scroll-info").css({ "display": "block" });
                                $(".text-scroll").css({ "color": "#000" });
                            }
                        });

                        umpApp.intro.timeline_scrollInfo.clear();
                        umpApp.intro.timeline_scrollInfo.to(".container-scroll-info", {
                            opacity: 0,
                            onComplete: function () {
                                $(".container-scroll-info").css({ "display": "none" });
                            }
                        });

                        umpApp.intro.timeline_scrollInfo.to(".container-scroll-info", {
                            opacity: 1, delay: 0,
                            onStart: function () {
                                $(".container-scroll-info").css({ "display": "block" });
                                $(".text-scroll").css({ "color": "#000" });
                            }
                        });
                    }
                });

            }
        },
        {//2 scene text 2 -> 3d 1
            play: function () {
                console.log("play slide ", umpApp.intro.slide);
                umpApp.intro.timeline_1s.clear();
                umpApp.intro.timeline_1s.to(".scene.text-two", {
                    onStart: function () {
                        //display 3d 1
                        $(".threed-one").css({ "display": "block" });
                        //play info text 
                        umpApp.intro.playInfoText = true;
                        requestAnimationFrame(umpApp.intro.animeInfoText);
                    },
                    height: 0,
                    onComplete: function () {
                        umpApp.intro.slidePlayed = 2;
                        //hide text 1 & 2
                        $(".scene.text-one, .scene.text-two").css({ "display": "none" });
                        //graph move ping pong
                        umpApp.intro.timeLine_16s.to(".graph-move", { y: "40vh", delay: 0 })
                            .to(".graph-move", { y: "25vh", repeat: -1, yoyo: true });

                        umpApp.intro.timeline_scrollInfo.clear();
                        umpApp.intro.timeline_scrollInfo.to(".container-scroll-info", {
                            opacity: 0,
                            onComplete: function () {
                                $(".container-scroll-info").css({ "display": "none" });
                            }
                        });

                        umpApp.intro.timeline_scrollInfo.to(".container-scroll-info", {
                            opacity: 1, delay: 0,
                            onStart: function () {
                                $(".container-scroll-info").css({ "display": "block" });
                                $(".text-scroll").css({ "color": "#000" });
                            }
                        });
                    }
                });
            },
            reverse: function () {
                console.log("reverse slide ", umpApp.intro.slide);
                umpApp.intro.timeline_1s.clear();
                umpApp.intro.timeline_1s.to(".scene.text-two", {
                    onStart: function () {
                        //hide text 1 & 2
                        $(".scene.text-one, .scene.text-two").css({ "display": "block" });
                    },
                    height: "100vh",
                    onComplete: function () {
                        umpApp.intro.slidePlayed = 1;
                        //hide 3d 1
                        $(".threed-one").css({ "display": "none" });

                        umpApp.intro.timeline_scrollInfo.clear();
                        umpApp.intro.timeline_scrollInfo.to(".container-scroll-info", {
                            opacity: 0,
                            onComplete: function () {
                                $(".container-scroll-info").css({ "display": "none" });
                            }
                        });

                        umpApp.intro.timeline_scrollInfo.to(".container-scroll-info", {
                            opacity: 1, delay: 0,
                            onStart: function () {
                                $(".container-scroll-info").css({ "display": "block" });
                                $(".text-scroll").css({ "color": "#fff" });
                            }
                        });
                    }


                });
            }
        },
        { //3 scene 3D 1 -> 3D 2
            play: function () {
                console.log("play slide ", umpApp.intro.slide);
                umpApp.intro.timeline_1s.clear();
                umpApp.intro.timeline_1s.to(".scene.threed-one", {
                    onStart: function () {
                        //display 3d 2
                        $(".threed-two").css({ "display": "block" });
                    },
                    height: 0,
                    onComplete: function () {
                        umpApp.intro.slidePlayed = 3;
                        //hide 3d 1
                        $(".threed-one").css({ "display": "none" });
                    }
                });
                // fade in & out 3D 1 -> 3D 2
                var size2 = 0.7;
                if (window.matchMedia("(max-device-width:480px)").matches) {
                    size2 = 0.20;
                } else {
                    if (ratio < 1.5) {
                        size2 = 0.5;
                    }
                }
                umpApp.intro.timeLine3dIn.to(objects3D[0].scale, {
                    x: 0,
                    y: 0,
                    z: 0,
                });
                umpApp.intro.timeLine3dOut.to(objects3D[1].scale, {
                    delay: 1,
                    x: size2,
                    y: size2,
                    z: size2,
                });

                umpApp.intro.timeline_scrollInfo.clear();
                umpApp.intro.timeline_scrollInfo.to(".container-scroll-info", {
                    opacity: 0,
                    onComplete: function () {
                        $(".container-scroll-info").css({ "display": "none" });
                    }
                });

                umpApp.intro.timeline_scrollInfo.to(".container-scroll-info", {
                    opacity: 1, delay: 0,
                    onStart: function () {
                        $(".container-scroll-info").css({ "display": "block" });
                        $(".text-scroll").css({ "color": "#fff" });
                    }
                });
            },
            reverse: function () {
                console.log("reverse slide ", umpApp.intro.slide);
                umpApp.intro.timeline_1s.clear();
                umpApp.intro.timeline_1s.to(".scene.threed-one", {
                    onStart: function () {
                        //display 3d 1
                        $(".threed-one").css({ "display": "block" });
                    },
                    height: "100vh",
                    onComplete: function () {
                        umpApp.intro.slidePlayed = 2;
                        //hide 3d 2
                        $(".threed-two").css({ "display": "none" });
                    }
                });
                // fade in & out 3D 1 -> 3D 2
                var size2 = 0.7;
                if (window.matchMedia("(max-device-width:480px)").matches) {
                    size2 = 0.2;
                } else {
                    if (ratio < 1.5) {
                        size2 = 0.5;
                    }
                }
                umpApp.intro.timeLine3dIn.to(objects3D[0].scale, {
                    x: size2,
                    y: size2,
                    z: size2,
                });
                umpApp.intro.timeLine3dOut.to(objects3D[1].scale, {
                    x: 0,
                    y: 0,
                    z: 0,
                });

                umpApp.intro.timeline_scrollInfo.clear();
                umpApp.intro.timeline_scrollInfo.to(".container-scroll-info", {
                    opacity: 0,
                    onComplete: function () {
                        $(".container-scroll-info").css({ "display": "none" });
                    }
                });

                umpApp.intro.timeline_scrollInfo.to(".container-scroll-info", {
                    opacity: 1, delay: 0,
                    onStart: function () {
                        $(".container-scroll-info").css({ "display": "block" });
                        $(".text-scroll").css({ "color": "#000" });
                    }
                });
            }
        },
        {//4 scene 3D 2 -> 3D 3
            play: function () {
                console.log("play slide ", umpApp.intro.slide);
                umpApp.intro.timeline_1s.clear();
                umpApp.intro.timeline_1s.to(".scene.threed-two", {
                    onStart: function () {
                        //display 3d 3
                        $(".threed-three").css({ "display": "block" });
                    },
                    height: 0,
                    onComplete: function () {
                        umpApp.intro.slidePlayed = 4;
                        //hide 3d 2
                        $(".threed-two").css({ "display": "none" });
                    }
                });
                // fade in & out 3D 2 -> 3D 3
                var size3 = 0.045;
                if (window.matchMedia("(max-device-width:480px)").matches) {
                    size3 = 0.018;
                } else {
                    if (ratio < 1.5) {
                        size3 = 0.030;
                    }
                }
                umpApp.intro.timeLine3dIn.to(objects3D[1].scale, {
                    delay: 0,
                    x: 0,
                    y: 0,
                    z: 0,
                    ease: Power1.easeInOut
                });
                umpApp.intro.timeLine3dOut.to(objects3D[2].scale, {
                    delay: 0.5,
                    x: size3,
                    y: size3,
                    z: size3,
                    ease: Power1.easeInOut
                });

                umpApp.intro.timeline_scrollInfo.clear();
                umpApp.intro.timeline_scrollInfo.to(".container-scroll-info", {
                    opacity: 0,
                    onComplete: function () {
                        $(".container-scroll-info").css({ "display": "none" });
                    }
                });

                umpApp.intro.timeline_scrollInfo.to(".container-scroll-info", {
                    opacity: 1, delay: 0,
                    onStart: function () {
                        $(".container-scroll-info").css({ "display": "block" });
                        $(".text-scroll").css({ "color": "#000" });
                    }
                });
            },
            reverse: function () {
                console.log("reverse slide 4! ", umpApp.intro.slide);
                umpApp.intro.timeline_1s.clear();
                umpApp.intro.timeline_1s.to(".scene.threed-two", {
                    onStart: function () {
                        //hide 3d 2
                        $(".threed-two").css({ "display": "block" });
                    },
                    height: "100vh",
                    onComplete: function () {
                        umpApp.intro.slidePlayed = 3;
                        //display 3d 3
                        $(".threed-three").css({ "display": "none" });
                    }
                });
                // fade in & out 3D 2 -> 3D 3
                var size3 = 0.7;
                if (window.matchMedia("(max-device-width:480px)").matches) {
                    size3 = 0.2;
                } else {
                    if (ratio < 1.5) {
                        size3 = 0.030;
                    }
                }
                umpApp.intro.timeLine3dIn.to(objects3D[1].scale, {
                    delay: 1,
                    x: size3,
                    y: size3,
                    z: size3,
                    ease: Power1.easeInOut
                });
                umpApp.intro.timeLine3dOut.to(objects3D[2].scale, {
                    delay: 0,
                    x: 0,
                    y: 0,
                    z: 0,
                    ease: Power1.easeInOut
                });

                umpApp.intro.timeline_scrollInfo.clear();
                umpApp.intro.timeline_scrollInfo.to(".container-scroll-info", {
                    opacity: 0,
                    onComplete: function () {
                        $(".container-scroll-info").css({ "display": "none" });
                    }
                });

                umpApp.intro.timeline_scrollInfo.to(".container-scroll-info", {
                    opacity: 1, delay: 0,
                    onStart: function () {
                        $(".container-scroll-info").css({ "display": "block" });
                        $(".text-scroll").css({ "color": "#fff" });
                    }
                });
            }
        },
        {//5 scene 3D 3 -> site web
            play: function () {
                console.log("play slide ", umpApp.intro.slide);
                umpApp.intro.timeline_1s.clear();
                umpApp.intro.slidePlayed = 5;


                umpApp.intro.timeLine3dOut.to(objects3D[2].scale, {
                    delay: 0,
                    x: 0,
                    y: 0,
                    z: 0,
                    ease: Power1.easeInOut,
                    onComplete: function () {
                        ump3Dintro.playAnimation = false;
                        umpApp.intro.timeline_1s.to(".scene.threed-three", {
                            top: "-100vh",
                            onComplete: function () {
                                //hide 3d 2
                                $(".threed-three").css({ "display": "none" });
                            }
                        });
                        umpApp.intro.timeline_sieWeb.to("#full-width-page-wrapper", {
                            top: 0,
                            onStart: function () {
                                //display site web
                                $("#full-width-page-wrapper").css({ "display": "block", "overflow-y": "visible" });
                                $("body, html").css({ "overflow-y": "visible" });
                                $("#sequence-info-text").css({ "display": "none" });

                                umpApp.intro.timeline_scrollInfo.clear();
                                umpApp.intro.timeline_scrollInfo.to(".container-scroll-info", {
                                    opacity: 0,
                                    onComplete: function () {
                                        $(".container-scroll-info").css({ "display": "none" });
                                    }
                                });
                            },
                        });
                    }
                });



            },
            reverse: function () {
                console.log("in reverse slide 5! ", umpApp.intro.slide);
                umpApp.intro.timeline_1s.clear();
                umpApp.intro.timeline_1s.to(".scene.threed-three", {
                    top: 0,
                    onStart: function () {
                        //hide 3d 2
                        $(".threed-three").css({ "display": "block" });
                    }
                });

                umpApp.intro.timeline_sieWeb.to("#full-width-page-wrapper", {
                    top: "100vh",
                    onComplete: function () {
                        umpApp.intro.slidePlayed = 4;
                        //hide site web
                        $("#full-width-page-wrapper").css({ "display": "none" });

                        umpApp.intro.timeline_scrollInfo.clear();
                        umpApp.intro.timeline_scrollInfo.to(".container-scroll-info", {
                            opacity: 0,
                            onComplete: function () {
                                $(".container-scroll-info").css({ "display": "none" });
                            }
                        });

                        umpApp.intro.timeline_scrollInfo.to(".container-scroll-info", {
                            opacity: 1, delay: 0,
                            onStart: function () {
                                $(".container-scroll-info").css({ "display": "block" });
                            }
                        });

                        var size3 = 0.045;
                        if (window.matchMedia("(max-device-width:480px)").matches) {
                            size3 = 0.018;
                        }
                        umpApp.intro.timeLine3dIn.to(objects3D[2].scale, {
                            delay: 0,
                            x: size3,
                            y: size3,
                            z: size3,
                            ease: Power1.easeInOut,
                        });
                    },
                });

            },
        },
        // {//6 
        //     play: function () {
        //         console.log("slide 6 play");
        //         umpApp.intro.slidePlayed = 6;
        //     },
        //     reverse: function () {
        //         console.log("slide 6 reverse");
        //         umpApp.intro.slidePlayed = 5;
        //     }
        // }
    ],
    start: function () {
        $("#toggle-ump").css({ "opacity": "1" });
        $("#select-lang").css({ "opacity": "1" });
        //menu burger
        $("#toggle-ump").click(function () {
            $(this).toggleClass("on");
        });
        $(window).on('hashchange', function (e) {
            e.preventDefault();
            console.log('hash changed',);
            var hashPage = window.location.href;
            console.log('hashPage: ', hashPage);
            //display site web
            $("#full-width-page-wrapper").css({ "display": "block", "overflow-y": "visible", "top": "0" });
            $("body, html").css({ "overflow-y": "visible" });
            //$("#intro-3d").css({ "display": "none" });
            $(".scene.text-one, .scene.text-two").css({ "display": "none", "height": "0px" });
            $(".scene.threed-one, .scene.threed-two").css({ "height": "0px" });
            $(".scene.threed-three").css({ "height": "100vh", "top": "-100vh" });
            // $(".threed-three").css({ "display": "none" });
            // $(".threed-two").css({ "display": "none" });
            // $(".threed-one").css({ "display": "none" });
            $("#sequence-info-text").css({ "display": "none" });
            $(".container-scroll-info").css({ "display": "none" });
            umpApp.intro.stop3dAndDisplaySite(true);
            window.location.href = hashPage;

        });

        //start 3d intro
        console.log('Intro start');
        $(".loader").css({ "display": "none" });
        umpApp.intro.timeline_scrollInfo.to(".container-scroll-info", {
            opacity: 1,
            onStart: function () {
                $(".container-scroll-info").css({ "display": "block" });
            }
        });
        this.seqTimeLine[this.slide].play();
        if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/Android/i)) {
            $(".container-scroll-info").css({ "top": "-48px" });
            $("#threedscene-three").css({ "top": "32px" });
            $("#threedscene-two").css({ "top": "32px" });
            $("#threedscene-one").css({ "top": "32px" });

        }
        // init auto scroll timer
        this.autoScroll();
        // init event scroll & touches
        this.eventScrollInit();
        //lance text info dès le départ, raison sync
        $("#sequence-info-text").css({ "display": "block" });
        // affiche text 2
        $(".scene.text-two").css({ "display": "block" });


    },
    autoScroll: function () {
        console.log('autoScroll: ', umpApp.intro.slidePlayed);
        var _this = this;
        var time = 5000;
        if (umpApp.intro.slidePlayed < 5) {
            if (umpApp.intro.slidePlayed === 0) {
                time = 3000;
            }
            var timer = setTimeout(function () {
                _this.goSlide(1);
                _this.autoScroll();
            }, time);
        }
    },
    stopEvents: function () {
        var scrollEvent = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';
        window.removeEventListener(scrollEvent, umpApp.intro.scrollCallback, true);
        $(document).unbind('touchstart', function () { });
        $(document).unbind('touchmove', function () { });
    },
    animeInfoText: function () {

        if (umpApp.intro.playInfoText) {
            //document.getElementById("bg-text-info").style.backgroundImage = "url(" + seqScr[umpApp.intro.indexFrame].src + ")";
            $("#bg-text-info").css({ "background-image": "url(" + seqScr[umpApp.intro.indexFrame].src + ")" });
            umpApp.intro.indexFrame++;
            if (umpApp.intro.indexFrame === 50) {
                umpApp.intro.indexFrame = 0;
            }
            umpApp.intro.idAF = requestAnimationFrame(umpApp.intro.animeInfoText);
        } else {

            setTimeout(() => {
                console.log('cancelAnimationFrame: ');
                cancelAnimationFrame(umpApp.intro.idAF);
            }, 1000);

        }
    },
    eventScrollInit: function () {
        console.log('eventScrollInit: ');
        var lastY;
        var scrollEvent = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';

        window.addEventListener(scrollEvent, umpApp.intro.scrollCallback, true);

        $(document).bind('touchstart', function (e) {
            lastY = e.originalEvent.touches[0].clientY;
        });

        $(document).bind('touchmove', function (event) {
            var currentY = event.originalEvent.touches[0].clientY;
            var power = currentY - lastY;

            if (power > 150) {
                console.log("+1");
                umpApp.intro.goSlide(-1);
            }
            else if (power < -150) {
                console.log("-1");
                umpApp.intro.goSlide(1);
            }
        });
    },
    scrollCallback: function (event) {
        console.log('scrollCallback: ');
        var normalized;

        if (event.wheelDelta) {
            normalized = (event.wheelDelta % 120 - 0) == -0 ? event.wheelDelta / 120 : event.wheelDelta / 12;
        } else {
            var rawAmmount = event.deltaY ? event.deltaY : event.detail;
            normalized = -(rawAmmount % 3 ? rawAmmount * 10 : rawAmmount / 3);
        }
        umpApp.intro.goSlide(-normalized);

    },
    goSlide: function (amout) {
        console.log('goSlide: ');
        console.log('this.timeBreak: ', this.timeBreak);
        var _this = this;
        var playSlide = false;
        if (this.timeBreak === false) {

            console.log('amout: ', amout);
            this.timeBreak = true;
            console.log('this.slide, umpApp.intro.slidePlayed: ', this.slide, umpApp.intro.slidePlayed);
            if (amout > 0) {
                if (this.slide === umpApp.intro.slidePlayed) {
                    this.slide++;
                    playSlide = true;
                }
            }
            if (amout < 0) {
                if (this.slide === umpApp.intro.slidePlayed) {
                    this.slide--;
                    playSlide = true;
                }

            }

            if (this.slide < 0) {
                this.slide = 0;
            }

            if (playSlide) {
                console.log('playSlide: ');
                console.log('this.slide: ', this.slide);
                if (this.slide === 5) {//affiche site
                    umpApp.intro.stop3dAndDisplaySite(false);
                } else {
                    if (this.slide < 5) {
                        console.log("slide < 5 ");
                        if (amout > 0) {//scroll down
                            console.log('Play slide: ', this.slide);
                            this.seqTimeLine[this.slide].play();
                        } else {// scroll up
                            console.log('scroll in 3d: ');
                            console.log('reverse slide: ', this.slide + 1);
                            //umpApp.intro.idAF = requestAnimationFrame(umpApp.intro.animeInfoText);
                            this.seqTimeLine[this.slide + 1].reverse();
                        }
                    }
                }


            }
            // !!!!!!!!!!!!!!!!!!!!!!!!!!!!
            if (this.slide < 5) {
                umpApp.intro.stopEvents();
                setTimeout(function () {
                    _this.timeBreak = false;
                    umpApp.intro.eventScrollInit();
                }, 1100);
            }
        }
    },
    initEventScrollTopSite: function () {
        console.log('initEventScrollTopSite: ');
        umpApp.intro.initEventScrollTopSite.counterMouseUpOnTop = 0;
        umpApp.intro.initEventScrollTopSite.counterTouchUpOnTop = 0;
        //mouse
        var scrollEvent = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';
        window.addEventListener(scrollEvent, umpApp.intro.scrollSiteCallback, true);

        //touch
        var lastY;
        $(document).bind('touchstart', function (e) {
            lastY = e.originalEvent.touches[0].clientY;
        });

        $(document).bind('touchmove', function (event) {
            var currentY = event.originalEvent.touches[0].clientY;
            var power = currentY - lastY;

            if (power > 150) {
                console.log("+1");

            }
            else if (power < -150) {
                console.log("-1");

            }
        });

    },
    scrollSiteCallback: function (event) {
        console.log('scrollCallback: ', $("#full-width-page-wrapper").scrollTop());

        var normalized;

        if (event.wheelDelta) {
            normalized = (event.wheelDelta % 120 - 0) == -0 ? event.wheelDelta / 120 : event.wheelDelta / 12;
        } else {
            var rawAmmount = event.deltaY ? event.deltaY : event.detail;
            normalized = -(rawAmmount % 3 ? rawAmmount * 10 : rawAmmount / 3);
        }
        //-normalized
        console.log('normalized: ', normalized);
        if ($("#full-width-page-wrapper").scrollTop() === 0 && normalized === 1) {
            umpApp.intro.initEventScrollTopSite.counterMouseUpOnTop++;
            console.log('umpApp.intro.initEventScrollTopSite.counterMouseUpOnTop: ', umpApp.intro.initEventScrollTopSite.counterMouseUpOnTop);
            if (umpApp.intro.initEventScrollTopSite.counterMouseUpOnTop === 3) {
                umpApp.intro.initEventScrollTopSite.counterMouseUpOnTop = 0;
                umpApp.intro.restart3D();
            }
        }
        if (normalized === -1) {
            umpApp.intro.initEventScrollTopSite.counterMouseUpOnTop = 0;
        }


    },
    stop3dAndDisplaySite: function (isHash) {
        if (!isHash) {
            umpApp.intro.seqTimeLine[this.slide].play();
        } else {
            this.slide = 5;
        }
        umpApp.intro.playInfoText = false;
        requestAnimationFrame(umpApp.intro.animeInfoText);
        umpApp.intro.autoScroll = function () { };
        umpApp.intro.stopEvents();
        //ump3Dintro.playAnimation = false; ?
        console.log("affiche site", this.slide);
        umpApp.intro.initEventScrollTopSite();
        umpApp.initSite.init();
    },
    restart3D: function () {
        var scrollEvent = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';
        window.removeEventListener(scrollEvent, umpApp.intro.scrollSiteCallback, true);
        setTimeout(function () {
            ump3Dintro.playAnimation = true;
            ump3Dintro.initSceneOne.animate();
            ump3Dintro.initSceneTwo.animate();
            ump3Dintro.initSceneThree.animate();
            umpApp.intro.timeBreak = false;
            umpApp.intro.slide = 5;
            umpApp.intro.slidePlayed = 5;
            umpApp.intro.seqTimeLine[umpApp.intro.slide].reverse();
            umpApp.intro.eventScrollInit();
            umpApp.intro.playInfoText = true;
            requestAnimationFrame(umpApp.intro.animeInfoText);
            $("#sequence-info-text").css({ "display": "block" });
        }, 1);
    },
};

